import { consola } from 'consola'
import { setAuthEntryPoint } from '@shared/lib'
import { useModalStore , modalStateEnum } from '@shared/model'
import { useCartStore } from '@entities/order'
import { useUserProfileStore } from '@entities/user'
import { useAuthState } from '~/entities/auth'


/**
 * Composable для действий в корзине
 */
export function useBasketActions() {
  const modalStore = useModalStore()
  const cartStore = useCartStore()
  const { isLoggedIn } = useAuthState()
  const userProfileStore = useUserProfileStore()
  
  /**
   * Обрабатывает нажатие на кнопку оформления заказа
   */
  function handlePlaceOrderClick(
    validateForm: () => boolean,
    updateOrderFormWithPoints: () => void,
  ): void {
    const isUserLoggedIn = isLoggedIn.value
    const isPhoneVerified = userProfileStore.getUser?.is_phone_verified
    
    // Проверяем авторизацию
    if (!isUserLoggedIn) {
      // «Не смог оформить без входа» — самый ценный разрез воронки авторизации.
      setAuthEntryPoint('basket')
      modalStore.open(modalStateEnum.Login)
      return
    }
    
    // Проверяем верификацию телефона
    if (!isPhoneVerified) {
      modalStore.open(modalStateEnum.PhoneConfirmationInstructions)
      return
    }
    
    // Валидируем форму
    if (!validateForm()) {
      consola.error('Ошибки валидации формы')
      return
    }
    
    // Обновляем форму с баллами
    updateOrderFormWithPoints()
    
    // Открываем модальное окно подтверждения заказа
    modalStore.open(modalStateEnum.OrderVerification)
  }
  
  /**
   * Открывает корзину
   */
  function openBasket(): void {
    cartStore.openBasket()
  }
  
  /**
   * Закрывает корзину
   */
  function closeBasket(): void {
    cartStore.closeBasket()
  }
  
  /**
   * Очищает корзину.
   * Возвращаем промис: у авторизованного очистка идёт на сервер и может упасть —
   * вызывающий обязан дождаться результата и показать ошибку, а не «очистить» экран.
   */
  function clearCart(): Promise<void> {
    return cartStore.clearCart()
  }
  
  /**
   * Проверяет авторизован ли пользователь
   */
  function isUserLoggedIn(): boolean {
    return isLoggedIn.value
  }
  
  /**
   * Проверяет верифицирован ли телефон пользователя
   */
  function isPhoneVerified(): boolean {
    return userProfileStore.getUser?.is_phone_verified || false
  }
  
  /**
   * Получает состояние авторизации и верификации
   */
  function getAuthState() {
    return {
      isLoggedIn: isUserLoggedIn(),
      isPhoneVerified: isPhoneVerified(),
    }
  }
  
  return {
    // Actions
    handlePlaceOrderClick,
    openBasket,
    closeBasket,
    clearCart,
    isUserLoggedIn,
    isPhoneVerified,
    getAuthState,
  }
}
